import { Icon } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';
import ConnectedModuleCard from '../../../ConnectedModuleCard';

import EmptyState from '../../../EmptyState';

type Props = {
  title: string;
  description: string;
  actionUrl: string;
  actionText: string;
};

const EmptyPropertyConditionModule = ({ title, description, actionUrl, actionText }: Props) => {
  return (
    <ConnectedModuleCard>
      <EmptyState
        data-testid="EmptyPropertyConditionModule"
        useCard={false}
        icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconChecklistFilled />} />}
        heading={title}
        body={description}
        primaryAction={{ label: actionText, href: actionUrl }}
      />
    </ConnectedModuleCard>
  );
};

export default EmptyPropertyConditionModule;
